



































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { Getter } from "vuex-class";
import SignalRHub from "@/services/SignalRHub";
import { AZNCONNECT_API } from "@/services/aznconnect-api";
import {
  ReferralModel,
  ReferralDetailsModel,
  RelatedReferralModel,
} from "@/types/aznconnect_api";
import { ReferralType, SignalREvents } from "@/types/types";
import { ApplicationConfiguration, UserPermissions } from "@/types/store";

import ESpoedDetailPane from "@/components/espoed/DetailPane.vue";
import ESpoedv2DetailPane from "@/components/espoedv2/DetailPane.vue";
import TriageDetailPane from "@/components/triage/DetailPane.vue";
import SelfReferrerDetailPane from "@/components/selfreferrer/DetailPane.vue";

@Component({
  components: {
    "espoed-detail-pane": ESpoedDetailPane,
    "espoedv2-detail-pane": ESpoedv2DetailPane,
    "triage-detail-pane": TriageDetailPane,
    "selfreferrer-detail-pane": SelfReferrerDetailPane,
  },
})
export default class DetailPane extends Vue {
  @Prop({ default: null })
  referralId!: string;

  @Prop({ default: false })
  isReadOnly!: boolean;

  @Prop({ default: true })
  allowPageClose!: boolean;

  @Prop({ default: null })
  signalRHub!: SignalRHub;

  loading: boolean = false;
  referralTypeEnum = ReferralType;
  referral: any = {};
  failedToLoad: boolean = false;

  @Getter("applicationConfiguration")
  applicationConfiguration!: ApplicationConfiguration;

  @Getter("userPermissions")
  userPermissions!: UserPermissions;

  allowLinkPatientNumber(): boolean {
    return (
      this.applicationConfiguration.patientNumberEditEnabled &&
      this.userPermissions.assignPatientNumber
    );
  }

  allowSetReferralState(): boolean {
    return (
      this.applicationConfiguration.manualCloseEnabled &&
      this.userPermissions.setReferralState
    );
  }

  allowProfessionalSummary(): boolean {
    return this.applicationConfiguration.professionalSummaryEnabled;
  }

  isTriageReferral(): boolean {
    return this.referral && this.referral.Type === this.referralTypeEnum.TRIAGE;
  }

  isEspoedReferral(): boolean {
    return (
      this.referral &&
      this.referral.Type === this.referralTypeEnum.ESPOED &&
      this.referral.Espoed &&
      this.referral.Espoed.TransportationId != null
    );
  }
  isEspoedv2Referral(): boolean {
    return (
      this.referral &&
      this.referral.Type === this.referralTypeEnum.ESPOED &&
      this.referral.Espoed &&
      this.referral.Espoed.TransportationId == null
    );
  }
  isSelfReferrerReferral(): boolean {
    return (
      this.referral && this.referral.Type === this.referralTypeEnum.SELFREFERRER
    );
  }

  copyLinkToClipboard(): void {
    const route = this.$router.resolve({
      name: "referral-details",
      params: { referralId: this.referralId },
    });
    const url = window.location.origin + "/" + route.href;

    let temp = $("<input>");
    $("body").append(temp);
    temp.val(url).select();
    document.execCommand("copy");
    temp.remove();
  }

  loadDetails(reference: string) {
    this.loading = true;
    this.failedToLoad = false;

    const vm = this;
    AZNCONNECT_API.get("/Referral/Get", { params: { id: reference } }).then(
      function(response) {
        var referralObj = response.data as ReferralDetailsModel;
        vm.referral = referralObj;

        vm.loading = false;
      },
      function(response) {
        // error callback
        vm.loading = false;
        vm.failedToLoad = true;
        vm.$router.go(-1);
      },
    );
  }

  closeDetails(): void {
    this.$emit("close");
  }

  @Watch("$route")
  private onRouteChanged(to: Route, from: Route): void {
    if (to.name === from.name) {
      if (this.referralId) {
        this.loadDetails(this.referralId);
      }
    }
  }

  mounted() {
    this.$emit("opened");
    if (this.referralId) {
      this.loadDetails(this.referralId);
    }
  }

  created() {
    if (this.signalRHub != null) {
      this.signalRHub.registerOnConnectedHandler(this.reconnectedHandler);
      this.signalRHub.hubProxy.on(
        SignalREvents.AddReferral,
        this.newReferralHandler,
      );
      this.signalRHub.hubProxy.on(
        SignalREvents.UpdatePatientNumber,
        this.updatedPatientNumberHandler,
      );
      this.signalRHub.hubProxy.on(
        SignalREvents.ManualReferralClose,
        this.manualReferralCloseHandler,
      );
      this.signalRHub.hubProxy.on(
        SignalREvents.UpdateEtaTime,
        this.etaTimeUpdatedHandler,
      );
    }
  }

  beforeDestroy(): void {
    if (this.signalRHub != null) {
      this.signalRHub.unregisterOnConnectedHandler(this.reconnectedHandler);
      this.signalRHub.hubProxy.off(
        SignalREvents.AddReferral,
        this.newReferralHandler,
      );
      this.signalRHub.hubProxy.off(
        SignalREvents.UpdatePatientNumber,
        this.updatedPatientNumberHandler,
      );
      this.signalRHub.hubProxy.off(
        SignalREvents.ManualReferralClose,
        this.manualReferralCloseHandler,
      );
      this.signalRHub.hubProxy.off(
        SignalREvents.UpdateEtaTime,
        this.etaTimeUpdatedHandler,
      );
    }
  }

  destroyed() {
    this.$emit("closed");
  }

  reconnectedHandler() {
    if (this.referralId) {
      this.loadDetails(this.referralId);
    }
  }

  newReferralHandler(referral: ReferralModel) {
    if (referral && referral.Reference == this.referralId) {
      this.loadDetails(this.referralId);
    }
  }

  updatedPatientNumberHandler(fieldEncounterId: string, patientNumber: string) {
    const referralModel = this.referral as ReferralDetailsModel;
    if (referralModel && referralModel.Reference == fieldEncounterId) {
      referralModel.PatientNumber = patientNumber;
    }
  }

  manualReferralCloseHandler(fieldEncounterId: string) {
    if (this.referral.Reference === fieldEncounterId) {
      //Close the referral to resemble server side state
      this.referral.State = "RESOLVED";
    }
  }

  etaTimeUpdatedHandler(referenceId: string, etaDate: string, etaTime: string) {
    const espoed = this.referral && this.referral.Espoed;
    if (espoed && espoed.Reference === referenceId) {
      this.$set(this.referral.Espoed, "EtaDate", etaDate);
      this.$set(this.referral.Espoed, "EtaTime", etaTime);
    }
  }
}
